import { Col, Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import "../../scss/freelancing-guide-styling-components/benefit-section.style.scss";
import { Benefits } from "../../constant/benefits-section.constant";
import { BenefitsHeroImage } from "../images/png/icons";
import { useTranslation } from "react-i18next";

export const BenefitSection = () => {
  const { t } = useTranslation();
  const BOOTSTRAP_MD_BREAKPOINT = 768;
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
  const isMobile = window.innerWidth < 576;

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container className="benefits-section-container padding-140-benefits-section">
      <Row className={`benefits-section-row align-items-center ${isLargeScreen ? "large-screen" : ""}`}>
        <Col md={6} className="benefits-section-content-col px-0 half-stretch-content">
          <div className={`benefits-section-content${isLargeScreen ? " large" : ""}`}>
            <h2 className="benefits-section-title">{t("BENEFIT_SECTION_TITLE")}</h2>
            <div style={{ height: "2rem" }} />
            <p className="benefits-section-description">{t("BENEFIT_SECTION_DESC")}</p>
            <div style={{ height: "3rem" }} />
            <Row>
              {Benefits.map(({ icon, title, description }, idx) => (
                <Col md={12} key={idx} className="benefits-section-feature-col">
                  <div>
                    <div className="benefits-section-feature-row">
                      <div className="benefits-section-feature-icon">
                        <img src={icon} alt={t(title)} />
                      </div>
                      <div className="benefits-section-feature-title-wrap">
                        <h3 className="benefits-section-feature-title">{t(title)}</h3>
                      </div>
                    </div>
                    <p className="benefits-section-feature-description">{t(description)}</p>
                  </div>
                </Col>
              ))}
            </Row>
          {isMobile && <img src={BenefitsHeroImage} alt={t("BENEFIT_IMAGE_ALT")} className="benefits-section-image" />}
          </div>
        </Col>

        {!isMobile && (
          <Col md={6} className="px-0 half-stretch" style={{
            border: "1px solid #E0E0E0",
            borderRadius: "20px",
          }}>
            <img src={BenefitsHeroImage} alt={t("BENEFIT_IMAGE_ALT")} className="benefits-section-image" />
          </Col>
        )}
      </Row>
    </Container>
  );
};
